// extracted by mini-css-extract-plugin
export var deleteIcon = "_oo-5";
export var deleteOption = "_oo-3";
export var divider = "_oo-2";
export var downloadIcon = "_oo-4";
export var drawer = "_oo-0";
export var drawerFooter = "_oo-6";
export var drawerOpen = "_oo-1";
export var highlighted = "_oo-7";
export var lighterHighlight = "_oo-8";